import { JsonObject } from 'json2typescript';
import { SimulationTargetGrowInterface } from '../interfaces/simulation-taget-grow.interface';

@JsonObject('SimulationTargetGrowModel')
export class SimulationTargetGrowModel
  implements SimulationTargetGrowInterface
{
  Currency?: string;
  ProfileId?: number;
  GoalAmount?: number;
  TimeHorizon?: number;
  InitialContributionAmount?: number;
  PeriodicContributionAmount?: number;
  PeriodicContributionFrequency?: string;
  Priority?: number;
  InitialDate?: string;//Data

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
